export enum IdStateNotification {
  DaRegistrare = '40',
  InElaborazione = '41',
  RegistrazioneEffettuata = '42',
  Annullata = '43',
}

export const getLabelStateNotification = (id: string): string => {
  switch (id) {
    case IdStateNotification.DaRegistrare:
      return 'Da registrare';
    case IdStateNotification.InElaborazione:
      return 'In elaborazione';
    case IdStateNotification.RegistrazioneEffettuata:
      return 'Registrazione effettuata';
    case IdStateNotification.Annullata:
      return 'Annullata';
    default:
      return '';
  }
};
